import { render, staticRenderFns } from "./AllergenList.vue?vue&type=template&id=7b797a4b&"
import script from "./AllergenList.vue?vue&type=script&lang=js&"
export * from "./AllergenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b797a4b')) {
      api.createRecord('7b797a4b', component.options)
    } else {
      api.reload('7b797a4b', component.options)
    }
    module.hot.accept("./AllergenList.vue?vue&type=template&id=7b797a4b&", function () {
      api.rerender('7b797a4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/AllergenList.vue"
export default component.exports